var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloseIcon = function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.912 8.955-.071-.071-.07.07L8.952 29.772l-.071.071.07.07 1.132 1.131.07.071.071-.07 20.818-20.817.07-.07-.07-.071-1.131-1.131Z",
    fill: "#362B24",
    stroke: "#362B24",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10.225 8.955-.07-.071-.071.07-1.131 1.133-.071.07.07.071L29.77 31.044l.071.07.07-.07 1.132-1.132.07-.07-.07-.071L10.225 8.955Z",
    fill: "#362B24",
    stroke: "#362B24",
    strokeWidth: 0.2
  })));
};
export default SvgCloseIcon;